import {IconChipMultiplePerson, IconPersonPlusCard} from "../../../../../../../components/buttons/IconButtons";
import {permissionObj} from "../../../../../../../Helpers/permission";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 * */
export const SPECIAL_PERMISSION_TAB = {
    ADD_EMPLOYEES:{
        key:0,
        name: "ADD_EMPLOYEES",
        translation: "add_employees",
        icon: <IconPersonPlusCard width={24} height={24}/>,
        permission: permissionObj?.WEB_USER_SPECIAL_PERMISSION_ASSIGN
    },
    ASSIGNED_EMPLOYEES:{
        key:1,
        name: "ASSIGNED_EMPLOYEES",
        translation: "assigned_employees",
        icon: <IconChipMultiplePerson width={24} height={24}/>,
        permission: permissionObj?.WEB_USER_SPECIAL_PERMISSION_READ
    },
    getTabsByPermission: (DEV, permission) => {
        return Object.values(SPECIAL_PERMISSION_TAB).filter(e => DEV || permission.includes(e.permission));
    }
}
